import React from 'react';

const Spinner = ({ size = 'h-12 w-12' }) => {
    return (
        <div className="flex justify-center items-center py-10">
            <div className={`animate-spin rounded-full ${size} border-b-2 border-light-primary dark:border-dark-primary`}></div>
        </div>
    );
};

export default Spinner;